<div matDialogTitle>{{'WARNING' | translate}}</div>
<div matDialogContent>
    <div class="message-content">{{message | translate}}</div>
</div>
<div matDialogActions align="end">
    <button mat-button color="accent" matDialogClose="">{{'CLOSE' | translate}}</button>
</div>
